import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { Table, Form, Button, Navbar, Nav, Offcanvas, Badge, InputGroup } from 'react-bootstrap';
import { Lista_cancelados } from "../../services/api";

const Alunos_cancelados = (props) => {
    const perfil = JSON.parse(localStorage.getItem("perfil"));
    const meu_perfil = perfil[0].perfil;

    const unidades = ['', 'Bento Ribeiro', 'Madureira', 'Santa Cruz', 'Cascadura', 'Taquara', 'Nilopolis', 'Nova Iguaçu', '', 'Seropédica', 'Barra da Tijuca', 'Campo Grande', 'Centro de Excelência', 'Mangueira', 'Maricá', 'Ilha do Governador', 'Freguesia', 'Recreio dos Bandeirantes'];
    const unidades_sigla = ['', 'BR', 'MD', 'SC', 'CD', 'TQ', 'NP', '', '', 'SP', 'BT', 'CG', 'CP', 'MG', 'MC', 'IG', 'FG', 'RB'];

    const navigate = useNavigate();

    // Configuração de Datas Padrão 
    const DATA_INICIO_DEFAULT = '2025-01-01';
    const amanha = new Date();
    amanha.setDate(amanha.getDate() + 1);
    const DATA_FIM_DEFAULT = amanha.toISOString().split('T')[0];

    // Estados
    const [data26, setData26] = useState([]);
    const [showFilters, setShowFilters] = useState(false);

    // Estados dos Filtros
    const [dataInicio, setDataInicio] = useState(DATA_INICIO_DEFAULT);
    const [dataFim, setDataFim] = useState(DATA_FIM_DEFAULT);
    const [unidadeFiltro, setUnidadeFiltro] = useState("");
    const [filtroTurma, setFiltroTurma] = useState("");
    const [filtroPlano, setFiltroPlano] = useState("");
    const [filtroTipoBolsa, setFiltroTipoBolsa] = useState("");
    const [bolsaMin, setBolsaMin] = useState(0);
    const [bolsaMax, setBolsaMax] = useState(100);

    const convertSegmento = (seg) => {
        const segmentos = {
            '0-1': 'Mat 1', '0-2': 'Mat 2', '0-3': 'Pré 1', '0-4': 'Pré 2',
            '1-1': '1º Fund I', '1-2': '2º Fund I', '1-3': '3º Fund I', '1-4': '4º Fund I', '1-5': '5º Fund I',
            '1-6': '6º Fund II', '1-7': '7º Fund II', '1-8': '8º Fund II', '1-9': '9º Fund II',
            '2-1': '1ª Médio', '2-2': '2ª Médio', '2-3': '3ª Médio'
        };
        return segmentos[seg] || seg;
    };

    const fetchData = async () => {
        try {
            const response = await Lista_cancelados();
            // Garantir unicidade por matrícula
            const dadosUnicos = [...new Map(response.map(item => [item.matricula, item])).values()];
            setData26(dadosUnicos);
        } catch (error) {
            console.error("Erro ao buscar dados:", error);
        }
    };

    useEffect(() => {
        fetchData();
    }, []);

    const handleLimparFiltros = () => {
        setDataInicio(DATA_INICIO_DEFAULT);
        setDataFim(DATA_FIM_DEFAULT);
        setUnidadeFiltro("");
        setFiltroTurma("");
        setFiltroPlano("");
        setFiltroTipoBolsa("");
        setBolsaMin(0);
        setBolsaMax(100);
    };

    // Lógica de Permissões
    let userUnidades = [];
    if (meu_perfil === "GESTOR") {
        userUnidades = unidades_sigla.map((_, i) => i).filter(i => i > 0 && unidades_sigla[i]);
    } else if (meu_perfil.startsWith("DIRETOR") || meu_perfil.startsWith("SECRETARIA")) {
        const numerosString = meu_perfil.replace(/DIRETOR|SECRETARIA/, "").trim();
        userUnidades = numerosString.split("-").map(n => parseInt(n));
    }

    // Processamento da Lista: Filtros + Ordenação Decrescente por Data
    const filteredData = data26
        .filter(item => {
            const codUnidade = parseInt(item.unidade);
            if (!userUnidades.includes(codUnidade)) return false;

            if (unidadeFiltro && codUnidade !== parseInt(unidadeFiltro)) return false;
            if (filtroTurma && item.turma !== filtroTurma) return false;
            if (filtroPlano && item.plano !== filtroPlano) return false;
            if (filtroTipoBolsa && item.tipo_bolsa !== filtroTipoBolsa) return false;

            const vBolsa = parseFloat(item.bolsa || 0);
            if (vBolsa < bolsaMin || vBolsa > bolsaMax) return false;

            if (item.data_ocorencia) {
                const dataOcorrencia = item.data_ocorencia.split('T')[0];
                if (dataOcorrencia < dataInicio || dataOcorrencia > dataFim) return false;
            } else {
                return false;
            }
            return true;
        })
        .sort((a, b) => {
            // ORDENAÇÃO PRINCIPAL: Data de Ocorrência (Decrescente)
            const dataA = new Date(a.data_ocorencia);
            const dataB = new Date(b.data_ocorencia);
            if (dataA > dataB) return -1;
            if (dataA < dataB) return 1;

            // Secundária: Unidade
            if (a.unidade !== b.unidade) return a.unidade - b.unidade;
            // Terciária: Nome
            return a.nome.localeCompare(b.nome);
        });

    // Cálculos de Resumo
    const totalAlunos = filteredData.length;
    const bolsaMedia = totalAlunos > 0
        ? (filteredData.reduce((acc, curr) => acc + parseFloat(curr.bolsa || 0), 0) / totalAlunos).toFixed(2)
        : 0;

    // Dados para os Selects
    const turmasDisponiveis = [...new Set(data26.map(item => item.turma))].filter(Boolean).sort();
    const planosDisponiveis = [...new Set(data26.map(item => item.plano))].filter(Boolean).sort();
    const tiposBolsaDisponiveis = [...new Set(data26.map(item => item.tipo_bolsa))].filter(Boolean).sort();

    const handleExportCSV = () => { /* Implementar lógica de exportação aqui */ };

    return (
        <div style={{ paddingBottom: '80px' }}>
            {/* Header / Navbar */}
            <Navbar sticky="top" className="bg-body-tertiary px-3 shadow-sm">
                <Button variant="outline-danger" onClick={() => setShowFilters(true)} className="me-3">
                    ☰ Filtros de Cancelamento
                </Button>
                <Nav.Link href="/" className="me-auto">Santa Mônica Rede de Ensino</Nav.Link>
                <Navbar.Brand className="me-auto fs-6 fw-bold text-danger">CANCELADOS</Navbar.Brand>

                <Form className="d-flex gap-2">
                    {meu_perfil === "GESTOR" && (
                        <Form.Select size="sm" value={unidadeFiltro} onChange={(e) => setUnidadeFiltro(e.target.value)}>
                            <option value="">Todas Unidades</option>
                            {userUnidades.map(cod => <option key={cod} value={cod}>{unidades[cod]}</option>)}
                        </Form.Select>
                    )}
                    <Button variant="danger" size="sm" onClick={() => navigate("/login")}>Sair</Button>
                </Form>
            </Navbar>

            {/* Painel de Pesquisa Lateral (Offcanvas) */}
            <Offcanvas show={showFilters} onHide={() => setShowFilters(false)} placement="start">
                <Offcanvas.Header closeButton className="bg-danger text-white">
                    <Offcanvas.Title>Filtrar Resultados</Offcanvas.Title>
                </Offcanvas.Header>
                <Offcanvas.Body>
                    <Form>
                        <Form.Group className="mb-3">
                            <Form.Label className="fw-bold">Período de Cancelamento</Form.Label>
                            <InputGroup size="sm" className="mb-2">
                                <InputGroup.Text>De</InputGroup.Text>
                                <Form.Control type="date" value={dataInicio} onChange={(e) => setDataInicio(e.target.value)} />
                            </InputGroup>
                            <InputGroup size="sm">
                                <InputGroup.Text>Até</InputGroup.Text>
                                <Form.Control type="date" value={dataFim} onChange={(e) => setDataFim(e.target.value)} />
                            </InputGroup>
                        </Form.Group>

                        <Form.Group className="mb-3">
                            <Form.Label className="fw-bold">Turma</Form.Label>
                            <Form.Select value={filtroTurma} onChange={(e) => setFiltroTurma(e.target.value)}>
                                <option value="">Todas as Turmas</option>
                                {turmasDisponiveis.map(t => <option key={t} value={t}>{t}</option>)}
                            </Form.Select>
                        </Form.Group>

                        <Form.Group className="mb-4">
                            <Form.Label className="fw-bold d-flex justify-content-between">
                                Faixa de Bolsa
                                <Badge bg="danger">{bolsaMin}% - {bolsaMax}%</Badge>
                            </Form.Label>
                            <div className="px-1 mt-2">
                                <small className="text-muted">Mínimo: {bolsaMin}%</small>
                                <Form.Range min="0" max="100" step="5" value={bolsaMin} onChange={(e) => setBolsaMin(parseInt(e.target.value))} />
                                <small className="text-muted">Máximo: {bolsaMax}%</small>
                                <Form.Range min="0" max="100" step="5" value={bolsaMax} onChange={(e) => setBolsaMax(parseInt(e.target.value))} />
                            </div>
                        </Form.Group>

                        <Form.Group className="mb-3">
                            <Form.Label className="fw-bold">Plano</Form.Label>
                            <Form.Select value={filtroPlano} onChange={(e) => setFiltroPlano(e.target.value)}>
                                <option value="">Todos</option>
                                {planosDisponiveis.map(p => <option key={p} value={p}>{p}</option>)}
                            </Form.Select>
                        </Form.Group>

                        <Form.Group className="mb-3">
                            <Form.Label className="fw-bold">Tipo de Bolsa</Form.Label>
                            <Form.Select value={filtroTipoBolsa} onChange={(e) => setFiltroTipoBolsa(e.target.value)}>
                                <option value="">Todos</option>
                                {tiposBolsaDisponiveis.map(b => <option key={b} value={b}>{b}</option>)}
                            </Form.Select>
                        </Form.Group>

                        <hr />
                        <Button variant="secondary" className="w-100 mb-2" onClick={handleLimparFiltros}>Limpar Tudo</Button>
                        <Button variant="danger" className="w-100" onClick={() => setShowFilters(false)}>Aplicar Filtros</Button>
                    </Form>
                </Offcanvas.Body>
            </Offcanvas>

            {/* Tabela de Resultados */}
            <div className="container-fluid mt-3 px-4">
                <div className="d-flex justify-content-between align-items-center mb-3">
                    <h5 className="mb-0">Relatório de Evasão</h5>
                    <Button variant="success" size="sm" onClick={handleExportCSV}>Exportar CSV</Button>
                </div>

                <div className="table-responsive">
                    <Table striped bordered hover size="sm" className="align-middle">
                        <thead className="table-dark text-center">
                            <tr>
                                <th>UNIDADE</th>
                                <th>MATRICULA</th>
                                <th>NOME</th>
                                <th>SÉRIE</th>
                                <th>TURMA</th>
                                <th>DATA CANC.</th>
                                <th>PLANO</th>
                                <th>TIPO BOLSA</th>
                                <th>BOLSA</th>
                            </tr>
                        </thead>
                        <tbody>
                            {filteredData.map((item, index) => {
                                const temPendencia = item.tipo_debito || item.tipo_restricao;
                                return (
                                    <tr key={index} style={temPendencia ? { color: 'red', fontWeight: 'bold' } : {}}>
                                        <td className="text-center small">{unidades[parseInt(item.unidade)]}</td>
                                        <td>{item.matricula}</td>
                                        <td className="small">{item.nome}</td>
                                        <td className="small">{convertSegmento(item.seg)}</td>
                                        <td className="text-center">{item.turma}</td>
                                        <td className="text-center">
                                            {item.data_ocorencia?.split('T')[0].split('-').reverse().join('/')}
                                        </td>
                                        <td className="small">{item.plano}</td>
                                        <td className="small">{item.tipo_bolsa}</td>
                                        <td className="text-center">{item.bolsa ? `${item.bolsa}%` : '0%'}</td>
                                    </tr>
                                );
                            })}
                        </tbody>
                    </Table>
                </div>
            </div>

            {/* Footer de Resumo */}
            <footer className="fixed-bottom bg-dark text-white p-2 shadow-lg">
                <div className="container-fluid d-flex justify-content-around align-items-center">
                    <span>Total de Alunos: <Badge bg="primary">{totalAlunos}</Badge></span>
                    <span>Bolsa Média: <Badge bg="danger">{bolsaMedia}%</Badge></span>
                </div>
            </footer>
        </div>
    );
}

export default Alunos_cancelados;